export * as B2C from './b2c';
